import script from "./RestaurantList.vue?vue&type=script&setup=true&lang=js"
export * from "./RestaurantList.vue?vue&type=script&setup=true&lang=js"

import "./RestaurantList.vue?vue&type=style&index=0&id=36b85297&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36b85297"]])

export default __exports__